import {
  validateRequest,
  validateResponseStatus
} from "./chunk-5YZBVQLS.mjs";
import {
  __decorateClass
} from "./chunk-AYNJNFEN.mjs";

// src/utils/utils.ts
import { Buffer } from "buffer";
import axios from "axios";
import {
  createCodeChallenge,
  createCodeVerifier,
  generateRandomString
} from "@inner-source/ciam-sdk";
function urlEncodeBase64(str) {
  const b64Chars = { "+": "-", "/": "_", "=": "" };
  return str.replace(/[+/=]/g, (m) => b64Chars[m] ?? "");
}
function encodeState(state) {
  return Buffer.from(JSON.stringify(state)).toString("base64");
}
var RequestBuilder = class {
  async get(requestUrl, options = {}) {
    return this.ValidateHTTPResponse(
      await axios.get(requestUrl, options)
    );
  }
  async post(requestUrl, data, options = {}) {
    return this.ValidateHTTPResponse(
      await axios.post(requestUrl, data, options)
    );
  }
  ValidateHTTPResponse(HTTPRawResponse) {
    return Promise.resolve(HTTPRawResponse.data);
  }
};
__decorateClass([
  validateRequest
], RequestBuilder.prototype, "get", 1);
__decorateClass([
  validateRequest
], RequestBuilder.prototype, "post", 1);
__decorateClass([
  validateResponseStatus
], RequestBuilder.prototype, "ValidateHTTPResponse", 1);
async function generateCodeChallenge() {
  const codeVerifier = createCodeVerifier();
  const codeChallenge = await createCodeChallenge(codeVerifier);
  sessionStorage.setItem("pcidCodeVerifierKey" /* PcidCodeVerifierKey */, codeVerifier);
  return codeChallenge;
}
function generateNonce() {
  const nonce = generateRandomString();
  sessionStorage.setItem("pcidNonceKey" /* PcidNonceKey */, nonce);
  return nonce;
}
function generateStateObj(payload) {
  const { relyingParty, intent, language, customProps } = payload.stateParams;
  const obj = {
    csrf: generateRandomString(),
    relyingParty,
    intent,
    language,
    scope: generateScope(payload.addOfflineAccessToScopes, payload.scope),
    keepMeSignedIn: payload.keepMeSignedIn,
    showIsThisYouPrompt: payload.showIsThisYouPrompt,
    // clientId is required to store values in local storage
    clientId: payload.clientId,
    customProps
  };
  sessionStorage.setItem("csrfKey" /* PcidCsrfKey */, obj.csrf);
  return Buffer.from(JSON.stringify(obj)).toString("base64");
}
function generateScope(addOfflineAccessToScopes, scopes) {
  const offlineAccess = addOfflineAccessToScopes ? " offline_access" : "";
  return `openid ${scopes}${offlineAccess}`;
}

export {
  urlEncodeBase64,
  encodeState,
  RequestBuilder,
  generateCodeChallenge,
  generateNonce,
  generateStateObj,
  generateScope
};
